import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { AuthProvider } from './contexts/auth';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCBfxR_2IWWnYM4qJfOa1_nYcyDbEWkowg",
  authDomain: "rn-fb-8ae3e.firebaseapp.com",
  projectId: "rn-fb-8ae3e",
  storageBucket: "rn-fb-8ae3e.appspot.com",
  messagingSenderId: "685939634370",
  appId: "1:685939634370:web:02721055c8ad32c93f0b5b",
  measurementId: "G-FE6X3CP8HJ"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export const db = getFirestore(app);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />

      </BrowserRouter>

    </AuthProvider>


  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
